<template>
  <b-overlay :show="loading">
    <FilesFilters
      :value="filters"
      :view="view"
      :onChange="onChangeFilters"
      :clear="clearFilters"
      :fechaName="'fechaInicioCreacion'"
      :fechaUntilName="'fechaFinCreacion'"
      :defaultDate="rangeSelected"
    />
    <FilesHeader/>
    <FileRow
      :key="file.id"
      v-for="file in files"
      :file="file"
      :refresh-list="refreshList"
      :select-file="selectFile"
    />
    <PopUpGeneralDetailFile
      v-if="showModal"
      :file="selectedFile"
    />
    <PopUpSendToDocDigital
      :file="selectedFile"
      v-if="selectedFile"
    />
  </b-overlay>
</template>
<script>

import { mapGetters } from 'vuex';

import { ddFiles } from '@/febos/servicios/api/docDigital.api';
import FilesHeader from '@/febos/chile/docDigital/components/FilesHeader';
import FileRow from '@/febos/chile/docDigital/components/FileRow';
import PopUpGeneralDetailFile from '@/febos/chile/docDigital/components/PopUpGeneralDetailFile';
import FilesFilters from '@/febos/chile/docDigital/components/FilesFilters';
import ConfigDocDigitalFiltersMixin from '@/febos/chile/docDigital/components/ConfigDocDigitalFiltersMixin';
import { DATE_RANGE_LAST_3_MONTH, DATE_RANGES } from '@/febos/chile/commons/dateCommons';
import PopUpSendToDocDigital from '@/febos/chile/dnt/vistas/modals/PopUpSendToDocDigital';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';
import { mergeFilters } from '@/febos/chile/dnt/utils/fitlers';

export default {
  mixins: [ConfigDocDigitalFiltersMixin],
  data() {
    const { view } = this.$route.params;
    return {
      page: 1,
      limit: null,
      loading: false,
      files: [],
      selectedFile: {},
      ranges: DATE_RANGES,
      rangeSelected: DATE_RANGE_LAST_3_MONTH,
      view,
      filters: ''
    };
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    showModal() {
      return this.selectedFile.id && this.modalName === 'PopUpGeneralDetailFile';
    }
  },
  methods: {
    changeFilters(newFilter) {
      console.log('newFilter', newFilter);
    },
    async refreshList() {
      const { view } = this.$route.params;
      if (view === 'salientes') {
        await this.fetchOutbox();
        return;
      }
      await this.fetchInbox();
    },
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      const { view } = this.$route.params;
      if (!onMounted) {
        if (this.page !== 1) {
          this.page = 1;
          // using else because this method has two responsibilities
        } else {
          // force each (if we change the page from 1 to 1 the watcher not run)
          if (view === 'salientes') {
            await this.fetchOutbox();
            return;
          }
          await this.fetchInbox();
        }
      } else {
        if (view === 'salientes') {
          await this.fetchOutbox();
          return;
        }
        await this.fetchInbox();
      }
    },
    clearFilters() {
      removeSearchParams(['filters']);
      // TODO: try to change to default filter state for current view.
      updateSearchParams({ page: 1 });
      this.$router.go();
    },
    getFilters() {
      return mergeFilters(this.filters, this.$route.query.filters);
    },
    formatObjectFilter() {
      const arrayFilters = this.getFilters().split('|');
      const objectFilters = {};

      arrayFilters.forEach((filter) => {
        const separateFilter = filter.split(':');
        const [key, value] = separateFilter;
        objectFilters[key] = value;
      });

      return objectFilters;
    },
    async fetchInbox() {
      this.loading = true;
      try {
        const response = await ddFiles(
          'get',
          '/api/documentos/recibidos',
          {
            ...this.formatObjectFilter()
          }
        );
        this.files = response;
      } finally {
        this.loading = false;
      }
    },
    async fetchOutbox() {
      this.loading = true;
      try {
        const response = await ddFiles(
          'get',
          '/api/documentos/creados',
          {
            ...this.formatObjectFilter()
          }
        );
        this.files = response;
      } finally {
        this.loading = false;
      }
    },
    selectFile(file) {
      this.selectedFile = file;
    }
  },
  components: {
    FilesFilters,
    FilesHeader,
    FileRow,
    PopUpGeneralDetailFile,
    PopUpSendToDocDigital
  }
};
</script>
